// ── 직원 관리 한 목록 — 표(PC) / 카드(휴대폰) + 쪽 넘기기 (2026-11-03 미남님 "직원·마케터 합치기") ──────
//   칸(결정 1a): 성명 · 구분 · 부서 · 근무유형 · 담당 회사 · 입사일자 · (전체 볼 때만 퇴사일자) · 상태 · 아이디 · 관리.
//   버튼(결정 2a): 4대보험 = 수정·비번초기화·퇴직처리 / 3.3% = 수정·비번초기화·담당 해제(퇴사는 수정 창의 퇴사일).
//   예전 UserTableView(직원 탭)·MarketerTabView(마케터 탭)의 쓰기 판정을 그대로 옮겼다 — 서버도 같은 판정을 한다.
import React from 'react';
import AdminColHeader from '../../../components/AdminColHeader';
import {
  tableWrapStyle, tableStyle, thStyle, tdStyle,
  paginationWrapStyle, paginationBtn,
  mobileListWrapStyle, mobileCardStyle, mobileCardHeadStyle,
  mobileInfoGridStyle, mobileInfoItemStyle, mobileInfoKeyStyle,
  mobileActionGridStyle, mobileEmptyStyle,
  activeBadgeStyle, resignedBadgeStyle,
  btn, resignBtn, tableActionBtn, tableResignBtn, actionColStyle,
} from './styles';
import { normalizeAttendanceTimeType, toDate, isNoId } from './utils';
import { KIND_INSURED, KIND_LABEL, rowKind, kindBadgeStyle, assignedCompaniesInfo } from './userRowKind';

function workScheduleLabel(row, attendanceTypeOptions) {
  if (rowKind(row) !== KIND_INSURED) return '-'; // 3.3% 는 근무유형(출퇴근)이 없다
  const current = normalizeAttendanceTimeType(row.attendance_time_type, attendanceTypeOptions) || '출근 없음';
  const next = row.next_work_schedule;
  if (!next?.effective_from) return current;
  const nextType = normalizeAttendanceTimeType(next.attendance_time_type, attendanceTypeOptions) || '출근 없음';
  return `${current} → ${next.effective_from}부터 ${nextType}`;
}

// 줄마다 보이는 버튼. 3.3% 쓰기 = 운영자 또는 이 회사 직원관리 — 담당이 없어 소속으로 보이는 줄(is_fallback)은
//   서버(marketer-write-scope)가 소속 회사로 보므로 그 회사 화면일 때만. 담당 목록에 없는 3.3% 줄(테넌트 소속만)은 예전 직원 탭 판정.
function rowActions(row, perms, companyCode) {
  if (rowKind(row) === KIND_INSURED) return { write: true, resign: true, unlink: false };
  const ownsFallback = String(row.company_code || 'PINE').toUpperCase() === String(companyCode || '').toUpperCase();
  const write = row.fromLinks
    ? perms.canManageMarketers || (perms.canManageCompanyMarketers && (!row.is_fallback || ownsFallback))
    : perms.canManageMarketers || perms.canManageCompanyMarketers;
  return { write, resign: false, unlink: Boolean(perms.canAssignMarketers && row.fromLinks && !row.is_fallback) };
}
const readOnlyTitle = '3.3% 인원은 그 회사의 직원 관리 권한이 있어야 수정할 수 있습니다.';

function Assigned({ row, companyCode }) {
  const info = assignedCompaniesInfo(row, companyCode);
  return <span style={info.muted ? { color: 'var(--text-muted)' } : undefined} title={info.title}>{info.text}</span>;
}

export function PeopleTableView({
  pagedList, list, loading, isMobile, attendanceTypeOptions, companyCode, includeResigned, perms,
  currentPage, totalPages, onEdit, onResetPassword, onDeactivate, onUnlink, onPageChange,
}) {
  const colCount = includeResigned ? 10 : 9;
  const status = (row) => {
    const resigned = Boolean(row.resign_date) || !row.is_active;
    return <span style={resigned ? resignedBadgeStyle : activeBadgeStyle}>{resigned ? '퇴직' : '재직중'}</span>;
  };
  const badge = (row) => <span style={kindBadgeStyle(rowKind(row))}>{KIND_LABEL[rowKind(row)]}</span>;
  const idText = (row) => (isNoId(row.user_id) ? '아이디 없음' : row.user_id);

  const buttons = (row, mobile) => {
    const a = rowActions(row, perms, companyCode);
    if (!a.write && !a.unlink) {
      return <span style={{ fontSize: 11, color: 'var(--text-muted)', ...(mobile ? { gridColumn: '1 / -1' } : {}) }} title={readOnlyTitle}>읽기 전용</span>;
    }
    const b = mobile ? btn : tableActionBtn;
    const danger = mobile ? { ...resignBtn, gridColumn: '1 / -1' } : tableResignBtn;
    return (
      <>
        {a.write && <button style={b} onClick={() => onEdit(row)}>수정</button>}
        {a.write && <button style={b} onClick={() => onResetPassword(row)}>비번초기화</button>}
        {a.write && a.resign && <button style={danger} onClick={() => onDeactivate(row)}>퇴직처리</button>}
        {a.unlink && <button style={danger} onClick={() => onUnlink(row.id, row.name)}>담당 해제</button>}
      </>
    );
  };

  return (
    <>
      {isMobile ? (
        <div style={mobileListWrapStyle}>
          {loading && <div style={mobileEmptyStyle}>로딩 중...</div>}
          {!loading && list.length === 0 && <div style={mobileEmptyStyle}>데이터가 없습니다.</div>}
          {!loading && pagedList.map((row) => (
            <article key={row.id} style={mobileCardStyle}>
              <div style={mobileCardHeadStyle}>
                <strong style={{ fontSize: 16 }}>{row.name || '-'} <span style={{ marginLeft: 4 }}>{badge(row)}</span></strong>
                {status(row)}
              </div>
              <div style={mobileInfoGridStyle}>
                <div style={mobileInfoItemStyle}><span style={mobileInfoKeyStyle}>부서</span><span>{row.department || '-'}</span></div>
                {rowKind(row) === KIND_INSURED
                  ? <div style={mobileInfoItemStyle}><span style={mobileInfoKeyStyle}>근무유형</span><span>{workScheduleLabel(row, attendanceTypeOptions)}</span></div>
                  : <div style={mobileInfoItemStyle}><span style={mobileInfoKeyStyle}>담당 회사</span><Assigned row={row} companyCode={companyCode} /></div>}
                <div style={mobileInfoItemStyle}><span style={mobileInfoKeyStyle}>아이디</span><span>{idText(row)}</span></div>
                <div style={mobileInfoItemStyle}><span style={mobileInfoKeyStyle}>입사일</span><span>{toDate(row.hire_date) || '-'}</span></div>
                {includeResigned && <div style={mobileInfoItemStyle}><span style={mobileInfoKeyStyle}>퇴사일</span><span>{toDate(row.resign_date) || '-'}</span></div>}
              </div>
              <div style={mobileActionGridStyle}>{buttons(row, true)}</div>
            </article>
          ))}
        </div>
      ) : (
        <div style={tableWrapStyle}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}><AdminColHeader label="성명" db="users.name" /></th>
                <th style={thStyle}><AdminColHeader label="구분" db="users.worker_type" /></th>
                <th style={thStyle}><AdminColHeader label="부서" db="users.department" /></th>
                <th style={thStyle}><AdminColHeader label="근무유형" db="users.attendance_time_type" /></th>
                <th style={thStyle}><AdminColHeader label="담당 회사" db="marketer_company_links.company_code" /></th>
                <th style={thStyle}><AdminColHeader label="입사일자" db="users.hire_date" /></th>
                {includeResigned && <th style={thStyle}><AdminColHeader label="퇴사일자" db="users.resign_date" /></th>}
                <th style={thStyle}><AdminColHeader label="상태" db="users.resign_date (computed)" /></th>
                <th style={thStyle}><AdminColHeader label="아이디" db="users.user_id" /></th>
                <th style={{ ...thStyle, ...actionColStyle }}>관리</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={colCount} style={{ ...tdStyle, textAlign: 'center', color: 'var(--text-muted)' }}>로딩 중...</td></tr>
              )}
              {!loading && list.length === 0 && (
                <tr><td colSpan={colCount} style={{ ...tdStyle, textAlign: 'center', color: 'var(--text-muted)' }}>데이터가 없습니다.</td></tr>
              )}
              {!loading && pagedList.map((row, rowIndex) => {
                // 마지막 행 밑줄 제거 — 카드 바깥 테두리와 겹쳐 2px처럼 보이는 문제 (2026-08-26)
                const cellStyle = rowIndex === pagedList.length - 1 ? { ...tdStyle, borderBottom: 'none' } : tdStyle;
                return (
                  <tr key={row.id}>
                    <td style={cellStyle}>{row.name}</td>
                    <td style={cellStyle}>{badge(row)}</td>
                    <td style={cellStyle}>{row.department || '-'}</td>
                    <td style={cellStyle}>{workScheduleLabel(row, attendanceTypeOptions)}</td>
                    <td style={cellStyle}><Assigned row={row} companyCode={companyCode} /></td>
                    <td style={cellStyle}>{toDate(row.hire_date) || '-'}</td>
                    {includeResigned && <td style={cellStyle}>{toDate(row.resign_date) || '-'}</td>}
                    <td style={cellStyle}>{status(row)}</td>
                    <td style={cellStyle}>{idText(row)}</td>
                    <td style={{ ...cellStyle, ...actionColStyle }}><div style={{ display: 'flex', gap: 5 }}>{buttons(row, false)}</div></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {list.length > 0 && (
        <div style={paginationWrapStyle}>
          <button style={paginationBtn} disabled={currentPage <= 1} onClick={() => onPageChange(Math.max(1, currentPage - 1))}>이전</button>
          <span style={{ color: 'var(--text-muted)', fontWeight: 600 }}>{currentPage} / {totalPages}</span>
          <button style={paginationBtn} disabled={currentPage >= totalPages} onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}>다음</button>
        </div>
      )}
    </>
  );
}
